import { gql } from '@apollo/client'

/**
 * @deprecated use fragment from here `src/gql/fragments/ProcessesDetails.graphql`
 */
export default gql`
    fragment ProcessesDetailsDeprecatedSecondaryProcessHardwareInstallationManualQuoteCalcFields on HardwareInstallationManualQuoteCalcFields {
        international {
            markupPercentage
            mpPayoutInCents
            mpPayoutPartsLimit
            leadTimeInDays
            leadTimePartsLimit
        }
        domestic {
            mpPayoutInCents
            markupPercentage
            mpPayoutPartsLimit
            leadTimeInDays
            leadTimePartsLimit
        }
        lineItems {
            supplier
            partNumber
            qtyPerPart
            pricePerPack
            qtyPerPack
        }
    }
    fragment ProcessesDetailsDeprecatedSecondaryProcess on QmrSecondaryProcessDetails {
        process {
            id
            name
            typeName
        }
        unitPriceInCents
        leadTimeInDays
        notes
        pricingAndLeadTimeFields {
            ... on SecondaryProcessManualQuoteCalcFields {
                international {
                    markupPercentage
                    mpPayoutInCents
                    mpPayoutPartsLimit
                    leadTimeInDays
                    leadTimePartsLimit
                }
                domestic {
                    mpPayoutInCents
                    markupPercentage
                    mpPayoutPartsLimit
                    leadTimeInDays
                    leadTimePartsLimit
                }
            }
            ... on HardwareInstallationManualQuoteCalcFields {
                ...ProcessesDetailsDeprecatedSecondaryProcessHardwareInstallationManualQuoteCalcFields
            }
        }
    }
    fragment processesDetailsDeprecated on QmrProcessesDetails {
        totalPrice {
            ... on EstimatedPrice {
                lowPriceInCents
                lowUnitPriceInCents
                highPriceInCents
                highUnitPriceInCents
            }
            ... on ExactPrice {
                priceInCents
                unitPriceInCents
            }
        }
        primaryProcess {
            process {
                id
                name
                platformProcessTypeId
            }
            price {
                ... on EstimatedPrice {
                    lowPriceInCents
                    lowUnitPriceInCents
                    highPriceInCents
                    highUnitPriceInCents
                }
                ... on ExactPrice {
                    priceInCents
                    unitPriceInCents
                }
            }
        }
        postProcesses {
            unitPriceInCents
            postProcessLeadTimeInDays
            postProcessNumParts
            postProcessInspectionCriteria
            postProcess {
                id
                name
                typeName
                colors {
                    id
                    name
                }
                thicknesses {
                    id
                    name
                    value
                }
            }
            postProcessThickness {
                id
                name
            }
            postProcessColor {
                id
                name
            }
        }
        secondaryProcesses {
            ...ProcessesDetailsDeprecatedSecondaryProcess
        }
        isBusinessAccountDiscountApplied
    }
`
